import { Component, OnInit } from '@angular/core';
import { PointsService } from '../../services/points.service';
import { MapService } from '../../services/map.service';
import { MenuManagementService } from '../services/menu-management.service';
import { ConfigurationService } from 'src/app/services/configuration.service';
import { GlobalSelectionControlService } from 'src/app/map/services/global-selection-control.service';
import { GenericControlService } from 'src/app/popup/services/generic-control.service';
import { AnnotationService } from 'src/app/services/annotation.service';
import { Draw } from 'ol/interaction';
import olMap from 'ol/Map';
import VectorSource from 'ol/source/Vector';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import GeoJSON from 'ol/format/GeoJSON';
import { AnnotationComponent } from 'src/app/popup/annotation/annotation.component';
import { AnnotationModel } from 'src/app/models/annotation';
import Circle from 'ol/geom/Circle';
import { TopLevelLayers } from './top-level-layers';
import { AnnotationType, FeatureType } from 'src/app/models/EnumTypes';
import { ProjectService } from 'src/app/services/project.service';
import { RouteSegmentsService } from 'src/app/services/route-segments.service';
import { AreaService } from 'src/app/services/area.service';
import { AreaComponent } from 'src/app/popup/area/area.component';
import { AreaModel } from 'src/app/models/area';
import { ModalConfirmationService } from 'src/app/services/modal-confirmation.service';
import { NavaidsFilterService } from 'src/app/services/navaids-filter.service';
import { ProceduresFilterService } from 'src/app/services/procedures-filter.service';
import { CoordinatePointsFilterService } from 'src/app/services/coordinate-points-filter.service';
import { AirSpaceBoundaryFilterService } from 'src/app/services/air-space-bondary-filter.service';
import { CoverageQuantitativeAssessmentComponent } from 'src/app/popup/calculations/coverage-quantitative-assessment/coverage-quantitative-assessment.component';
import { CalculationsService } from 'src/app/services/calculations.service';
import { TrajectoryFilterService } from 'src/app/services/trajectory-filter.service';
import { HorizonToolService } from 'src/app/services/horizon-tool.service';
import { CalculationsControlService } from 'src/app/services/calculations-control.service';
import { CrossSectionService } from 'src/app/services/cross-section.service';
import { TabsService } from 'src/app/services/tabsService';
import { ParentLayers } from './parent-layer';
import { UtilsService } from 'src/app/services/utils.service';
import { ObstacleDataService } from 'src/app/services/obstacle-data.service';
import { ColorInterval } from 'src/app/popup/flight-inspection-style/flight-inspection-style.component';
import { UserSettingsService } from 'src/app/services/userSettings.service';
import { Layer, VectorLayerDMTR } from './layer';
import KML from 'ol/format/KML';
import { HttpClient } from '@angular/common/http';
import { EndpointsService } from 'src/app/services/endpoints.service';
import { LayerVisibility, UserLayer, UserSettings, UserSettingsDTO } from 'src/app/models/UserSettings';
import { ExportControlService } from 'src/app/popup/services/export-control.service';
import { Feature } from 'ol';
import { ExportDataService } from 'src/app/services/export-data';
import { StyleEditorComponent } from 'src/app/popup/style-editor/style-editor.component';
import { ConfigurationLayerModel, ConfigurationModel } from 'src/app/models/configuration';
import { cloneDeep, isEqual } from 'lodash';
import { CoordenateService } from 'src/app/services/coordenate.service';
import { Geometry, GeometryCollection } from 'ol/geom';
import { SelectByFirComponent } from 'src/app/popup/select-by-fir/select-by-fir.component';
@Component({
  selector: 'app-view-menu',
  templateUrl: './view-menu.component.html',
  styleUrls: ['./view-menu.component.scss'],
  standalone: false
})
export class ViewMenuComponent implements OnInit {
  map: olMap;
  draw: Draw;
  color: string = '#0f9ad5';
  annotationHiddenMenuActive: boolean = false;

  // zIndex => it is the index of each layer with respect to its order on the map.
  // it has to do with moving features to front and back
  private layerFrontZIndex = 100; // gets incremented each time a layers is moved to front

  public navaidIdentCodeEnabled: boolean = false;

  constructor(
    public globalSelectionService: GlobalSelectionControlService,
    private modalConfirmation: ModalConfirmationService,
    public menuService: MenuManagementService,
    public pointsService: PointsService,
    public configurationService: ConfigurationService,
    public mapService: MapService,
    public genericModalService: GenericControlService,
    public routeSegmentsService: RouteSegmentsService,
    public annotationService: AnnotationService,
    public areaService: AreaService,
    protected projectService : ProjectService,
    private popupService : BsModalService,
    public calculationsService : CalculationsService,
    public horizonToolService: HorizonToolService,
    public trajectoryFilterService: TrajectoryFilterService,
    public calculationControlService: CalculationsControlService,
    public tabsService: TabsService,
    public crossSectionService: CrossSectionService,
    public utilsService: UtilsService,
    public obstacleDataService: ObstacleDataService,
    public userServiceSettings: UserSettingsService,
    public http: HttpClient,
    public endpointService: EndpointsService,
    public exportService: ExportControlService,
    public exportDataService: ExportDataService,
    public rcsControl: CoordenateService
  ) {
    this.map = mapService.getMap('map');
  }

  ngOnInit(): void {}

  redrawText() {
    this.navaidIdentCodeEnabled = !this.navaidIdentCodeEnabled;
    this.pointsService.showNavaidsIdOnMap =
      !this.pointsService.showNavaidsIdOnMap;
    this.map.redrawText();
  }

  addArea(): void {
    const bsModalRef: BsModalRef = this.popupService.show(AreaComponent);
    bsModalRef.content.edit = false;
  }

  editArea(area: AreaModel): void {
    const bsModalRef: BsModalRef = this.popupService.show(AreaComponent);
    bsModalRef.content.edit = true;
    bsModalRef.content.model = cloneDeep(area);
  }

  annotationTrigger(): void {
    this.annotationHiddenMenuActive = !this.annotationHiddenMenuActive;
  }
  storeLayerVisibility(type: string, layer: Layer, notStoreInDB?: boolean) {
    let visibilityObject: any =
      this.userServiceSettings.getVisibilityObjectOfLayer(type);
    if (this.userServiceSettings.visibilityOfLayerIsStoredInArray(type)) {
      let visibilityLayer: LayerVisibility = visibilityObject.find(
        (elem: LayerVisibility) => elem.id == layer.id
      );
      if (visibilityLayer != null) {
        visibilityLayer.visible = layer.visible;
      }
    } else {
      visibilityObject[layer.id] = layer.visible;
    }

    if (notStoreInDB) return;

    this.userServiceSettings.updateSettings();
  }
  selectLayer(
    type: string,
    selectedLayer: Layer | TopLevelLayers | ParentLayers,
    event?
  ) {
    let layers: Layer[];
    if (selectedLayer instanceof TopLevelLayers) {
      layers = selectedLayer.layers;
    } else if (selectedLayer instanceof ParentLayers) {
      layers = [];
      selectedLayer.childLayers.forEach((child) => {
        layers.push(...child.layers);
      });
    } else {
      layers = [selectedLayer];
    }
    for (let layer of layers) {
      if (event) {
        layer.visible = event.target.checked;
        layer.olLayer.setVisible(event.target.checked);
      } else {
        TopLevelLayers.onSelect(layer);
      }
      for (const feature of layer.olLayer.getSource().getFeatures()) {
        if (this.pointsService.getSelectedFeatures().includes(feature)) {
          this.globalSelectionService.removeSelectedFeature(feature);
        }
      }
      this.storeLayerVisibility(type, layer, true);
    }
    this.userServiceSettings.updateSettings();
  }
  selectuserLayer(layer: Layer) {
    layer.visible = !layer.visible;
    layer.olLayer.setVisible(layer.visible);
    this.userServiceSettings.userSettings.userLayers.find(
      (userlayer: UserLayer) => userlayer.id == JSON.parse(layer.id)
    ).visible = layer.visible;
    this.userServiceSettings.updateSettings();
  }
  addAnnotation(event: any): void {
    this.annotationHiddenMenuActive = false;
    if (!this.projectService.projectEditable()) {
      return;
    }
    if (this.draw != null) {
      this.map.removeInteraction(this.draw);
    }
    //const source = this.mapService.selectionSource;
    const source = new VectorSource();
    let type = event;
    let freeHand: boolean = false;
    if (event == 'Freehand') {
      freeHand = true;
      type = 'LineString';
    } else if (event == 'Text') {
      type = 'Point';
    }
    this.draw = new Draw({
      source: source,
      type: type,
      freehand: freeHand,
    });
    this.map.addInteraction(this.draw);
    let context = this;
    this.draw.on('drawend', function (endEvent) {
      endEvent.feature.setProperties({ featureType: FeatureType.Annotation });
      if (event == 'Circle') {
        let transformedGeometry: Circle = endEvent.feature
          .getGeometry()
          .clone()
          .transform(context.rcsControl.activeRCS.epsg, 'EPSG:3857') as Circle;
        endEvent.feature.set('radius', transformedGeometry.getRadius());
        endEvent.feature.set('center', transformedGeometry.getCenter());
      }
      context.createAnnotationModel(source, AnnotationType[event]);
    });
  }

  createAnnotationModel(
    source: VectorSource,
    annotationType: AnnotationType
  ): void {
    const bsModalRef: BsModalRef = this.popupService.show(AnnotationComponent);
    bsModalRef.content.edit = false;
    bsModalRef.content.source = source;
    bsModalRef.content.model.lineWidth =
      annotationType == AnnotationType.Text ? 20 : 2;
    bsModalRef.content.model.annotationType = annotationType;
    this.map.removeInteraction(this.draw);
    this.draw = null;
  }

  editAnnotation(layer: TopLevelLayers): void {
    if (!this.projectService.projectEditable()) {
      return;
    }
    let model: AnnotationModel;
    this.pointsService.annotations.forEach((el) => {
      if (el.name == layer.name) {
        model = el;
      }
    });
    const bsModalRef: BsModalRef = this.popupService.show(AnnotationComponent);
    bsModalRef.content.edit = true;
    bsModalRef.content.model = model;
    bsModalRef.content.oldName = model.name;
  }

  getFlightInspectionLayers() {
    let layers = [];
    this.globalSelectionService.flightInspectionLayer.childLayers.forEach(
      (toplevel: TopLevelLayers) => {
        layers.push(toplevel.layers[0]);
      }
    );
    return layers;
  }

  moveAnnotation(layer: TopLevelLayers): void {
    if (!this.projectService.projectEditable()) {
      return;
    }
    this.globalSelectionService.clearAllSelected();
    layer.layers.forEach((l) => {
      l.olLayer
        .getSource()
        .getFeatures()
        .forEach((feat) => {
          this.globalSelectionService.setSelectedFeature(l.olLayer, feat);
        });
    });
  }

  deleteRouteSegment(layer: TopLevelLayers): void {
    this.modalConfirmation.showMesssageConfirmationModal(
      'Delete Route Segments',
      'Do you want to delete the selected Route Segments?',
      'Yes',
      'No',
      () => {
        this.globalSelectionService.routeSegmentsLayers.deleteLayer(layer);
        let index =
          this.userServiceSettings.userSettings.routeSegmentVisibilities.findIndex(
            (layerVisibility: LayerVisibility) =>
              JSON.stringify(layerVisibility.id) == layer.layers[0].id
          );
        this.userServiceSettings.userSettings.routeSegmentVisibilities.splice(
          index,
          1
        );
        this.userServiceSettings.updateSettings();
        this.routeSegmentsService.deleteRouteSegments(layer.layers[0].id);
      }
    );
  }

  deleteAnnotationAction(child: TopLevelLayers) {
    this.modalConfirmation.showMesssageConfirmationModal(
      'Delete',
      'Do you want to delete the annotation?',
      'Yes',
      'No',
      () => this.deleteAnnotation(child)
    );
  }

  deleteAnnotation(child: TopLevelLayers) {
    this.globalSelectionService.annotationLayers.deleteLayer(child);
    this.annotationService.deleteAnnotation(child.name);
    let index: number =
      this.userServiceSettings.userSettings.annotationsVisibility.findIndex(
        (elem) => elem.id == child.layers[0].name
      );
    if (index != -1) {
      this.userServiceSettings.userSettings.annotationsVisibility.splice(
        index,
        1
      );
      this.userServiceSettings.updateSettings();
    }
  }
  deleteUserLayer(i: number) {
    let layerToDelete: Layer = this.globalSelectionService.userLayer.childLayers[0].layers[i];
    this.modalConfirmation.showMesssageConfirmationModal("Remove Layer",
    "You are about to delete " +layerToDelete.name+" from GRIT. This action will not delete the original file from the disk.","Ok","Cancel",()=>{
      this.userServiceSettings.userSettings.userLayers.findIndex((layer:UserLayer) => layer.id == JSON.parse(layerToDelete.id));
      this.userServiceSettings.userSettings.userLayers.splice(i,1);
      this.userServiceSettings.updateSettings();
      layerToDelete.olLayer.getSource().clear();
      this.globalSelectionService.userLayer.childLayers[0].layers.splice(i,1);
    } )
  }
  deleteStaticLayer(layer: ConfigurationLayerModel) {
    this.modalConfirmation.showMesssageConfirmationModal("Remove Layer",
    "You are about to delete " +layer.name+" from GRIT. This action will not delete the original file from the disk.","Ok","Cancel",
    ()=>{
      let i = this.userServiceSettings.userSettings.staticGeoJsonLayers.findIndex((layer:UserLayer) => layer.id == layer.id);
      this.userServiceSettings.userSettings.staticGeoJsonLayers.splice(i,1);
      this.userServiceSettings.updateSettings();
      this.configurationService.currentConfiguration.layers=this.configurationService.currentConfiguration.layers
      .filter(configlayer=> configlayer.id !=layer.id );
      var config = ConfigurationModel.mapToService(this.configurationService.currentConfiguration);
      this.configurationService.saveConfiguration(config).subscribe(()=>{});
      if(layer.vectorLayer != null){
        let mapLayers:VectorLayerDMTR[] = this.map.getLayers().getArray() as VectorLayerDMTR[];
        let mapLayer = mapLayers.find((olLayer:VectorLayerDMTR)=> isEqual(layer.vectorLayer.olLayer.getSource(),olLayer.getSource()));
        this.map.removeLayer(mapLayer);
      }


      })
  }
  showStyleEditor(layer: Layer, staticLayer?: boolean) {
    let userLayer: UserLayer;
    if (staticLayer == null) {
      userLayer = this.userServiceSettings.userSettings.userLayers.find(
        (userLayer: UserLayer) => userLayer.id == JSON.parse(layer.id)
      );
    } else {
      userLayer =
        this.userServiceSettings.userSettings.staticGeoJsonLayers.find(
          (userLayer: UserLayer) => userLayer.id == JSON.parse(layer.id)
        );
    }
    StyleEditorComponent.showStyleEditor(
      this.popupService,
      layer,
      userLayer,
      staticLayer
    );
  }
  showNavaidFilter() {
    this.tabsService.openNewToolsTab(TabsService.NAVAID_FILTER);
  }
  showCPFilter(){
    this.tabsService.openNewToolsTab(TabsService.CP_FILTER);
  }
  showProcedureFilter() {
    this.tabsService.openNewToolsTab(TabsService.PROCEDURE_FILTER);
  }
  openTrajectoryFilter() {
    this.tabsService.openNewToolsTab(TabsService.TRAJECTORY_FILTER);
  }
  openAirSpaceBoundaryFilter() {
    this.tabsService.openNewToolsTab(TabsService.AIR_SPACE_BOUNDARY_FILTER);
  }
  openSAAMFilter() {
    this.tabsService.openNewToolsTab(TabsService.SAAM_Filter);
  }

  selectAll(layerType: ParentLayers, event) {
    if (
      layerType.name == 'Static Layers' ||
      layerType.name == 'Flight Inspection' ||
      layerType.name == 'FI Processing Tool' ||
      layerType.name == 'User Layers' ||
      layerType.name == 'Annotations'
    ) {
      let layers: TopLevelLayers[] = null;
      let i = 0;
      if (layerType.name == 'Static Layers') {
        for (const layer of this.configurationService?.currentConfiguration?.layers) {
          if (event.target.checked != layer.visible) {
            if (event.target.checked) {
              this.userServiceSettings.userSettings.visibleStaticLayerIDs.push(
                layer.id
              );
            } else {
              let index =
                this.userServiceSettings.userSettings.visibleStaticLayerIDs.findIndex(
                  (id) => id == layer.id
                );
              this.userServiceSettings.userSettings.visibleStaticLayerIDs.splice(
                index,
                1
              );
            }
            this.mapService.activateLayer(layer);
            this.userServiceSettings.updateSettings();
          }
        }

        layers = this.globalSelectionService.staticLayers.childLayers;
        i = 1;
      } else {
        if (layerType.name == 'Flight Inspection') {
          layers =
            this.globalSelectionService.flightInspectionLayer.childLayers;
        } else if (layerType.name == 'FI Processing Tool') {
          layers = this.globalSelectionService.processingToolLayer.childLayers;
        } else if (layerType.name == 'Annotations') {
          layers = this.globalSelectionService.annotationLayers.childLayers;
        } else {
          layers = this.globalSelectionService.userLayer.childLayers;
        }
        for (i; i < layers.length; i++) {
          if (event.target.checked) {
            layers[i].showAll();
          } else {
            layers[i].hideAll();
          }
        }
      }

      if (layerType.name == 'User Layers') {
        this.userServiceSettings.userSettings.userLayers.forEach(
          (layer: UserLayer) => {
            layer.visible = event.target.checked;
          }
        );
      }
      this.userServiceSettings.updateSettings();
      return;
    }
    for (const layer of layerType.childLayers[0].layers) {
      if (
        (layer.id == 'assessment' || layer.id == 'assessmentoffset') &&
        layerType.name == 'Procedures'
      ) {
        continue;
      }
      if (event.target.checked) {
        layer.visible = false;
      } else {
        layer.visible = true;
      }
      TopLevelLayers.onSelect(layer);
      for (const feature of layer.olLayer.getSource().getFeatures()) {
        if (this.pointsService.getSelectedFeatures().includes(feature)) {
          this.globalSelectionService.removeSelectedFeature(feature);
        }
      }
      this.storeLayerVisibility(layerType.name, layer, true);
    }
    this.userServiceSettings.updateSettings();
    if (
      layerType.name == 'Procedures' &&
      this.globalSelectionService.routeSegmentsLayers.childLayers.length > 0
    ) {
      for (const child of this.globalSelectionService.routeSegmentsLayers
        .childLayers) {
        this.selectLayer('Route Segments', child, event);
      }
    }
  }

  checkAllRouteSegmentsVisible(): boolean {
    if (
      !this.globalSelectionService.routeSegmentsLayers.childLayers ||
      this.globalSelectionService.routeSegmentsLayers.childLayers.length == 0
    ) {
      return true;
    }

    for (const child of this.globalSelectionService.routeSegmentsLayers
      .childLayers) {
      if (!child.allVisible()) {
        return false;
      }
    }

    return true;
  }

  deleteStaticObstacleLayer(layer: TopLevelLayers) {
    this.modalConfirmation.showMesssageConfirmationModal(
      'Delete Obstacle',
      'Do you want to delete the selected Obstacles?',
      'Yes',
      'No',
      () => {
        layer.status = false;
        this.globalSelectionService.staticLayers.deleteLayer(layer);
        this.obstacleDataService.deleteObstacle(
          layer.name,
          this.projectService.activeProject.id
        );
      }
    );
  }
  getFlightInspectionLegend(colorInterval: ColorInterval) {
    if (colorInterval.isMinValueInfinite) {
      return '< ' + colorInterval.maxValue;
    }
    if (colorInterval.isMaxValueInfinite) {
      return '> ' + colorInterval.minValue;
    }
    return colorInterval.minValue + ' to ' + colorInterval.maxValue;
  }

  moveLayersToFront(layers: any) {
    if (layers && layers.length > 0 && layers[0] instanceof TopLevelLayers) {
      for (const layer of layers as TopLevelLayers[]) {
        this.moveLayersToFrontImpl(layer.layers);
      }
    } else if (layers && layers.length > 0) {
      this.moveLayersToFrontImpl(layers as Layer[]);
    } else {
      return;
    }
  }
  moveLayersToBack(layers: any) {
    if (layers && layers.length > 0 && layers[0] instanceof TopLevelLayers) {
      for (const layer of layers as TopLevelLayers[]) {
        this.moveLayersToBackImpl(layer.layers);
      }
    } else if (layers && layers.length > 0) {
      this.moveLayersToBackImpl(layers as Layer[]);
    } else {
      return;
    }
  }

  private moveLayersToFrontImpl(layers: Layer[]) {
    if (this.layerFrontZIndex >= Number.MAX_SAFE_INTEGER) {
      // prevents the user from incrementing this.layerFrontZIndex indifinitely
      this.resetLayersZIndex();
    }
    for (const layer of layers) {
      layer.olLayer.setZIndex(this.layerFrontZIndex);
    }
    this.layerFrontZIndex++;
  }

  private moveLayersToBackImpl(layers: Layer[]) {
    for (const layer of layers) {
      layer.olLayer.setZIndex(0);
    }
  }

  private resetLayersZIndex() {
    this.layerFrontZIndex = 100;
    for (const layer of this.map.getLayers().getArray()) {
      layer.setZIndex(0);
    }
  }

  exportAllAnnotationsToShapeFile(childLayers: TopLevelLayers[]) {
    this.exportDataService.exportDataToShapeFile(
      childLayers.flatMap((topLevel) => topLevel.layers)
    );
  }

  exportAllAnnotationsToKML(childLayers: TopLevelLayers[]) {
    this.exportDataService.exportDataToKML(
      childLayers.flatMap((topLevel) => topLevel.layers)
    );
  }

  protected readonly FeatureType = FeatureType;
  protected readonly TabsService = TabsService;
  showSelectionByFir() {
    this.globalSelectionService.clearAllSelectedTools();
    this.popupService.show(SelectByFirComponent);
  }
}


